import { Component, Input, OnInit, Signal, inject } from "@angular/core";
import { StateModule } from "projects/shared-state/lib/state.module";
import { NewProfileComponent } from "./new-profile/new-profile.component";
import { User } from "firebase/auth";
import { WorkflowState } from "projects/shared-state/public-api";
import { StateService } from "projects/shared-state/lib/state.service";
import { ProfileComponent } from "./profile/profile.component";
import { CommonModule } from "@angular/common";
import {
  AppProfile,
  PromptConfig,
} from "projects/shared-state/lib/types/types";
import { AiHubLoaderService } from "@aihub/ui/loader";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  standalone: true,
  selector: "postgenie-app-profile",
  templateUrl: "./app-profile.component.html",
  styleUrls: ["./app-profile.component.scss"],
  imports: [StateModule, ProfileComponent, NewProfileComponent, CommonModule],
})
export class AppProfileComponent implements OnInit {
  @Input() user: User;
  profileForm!: any;

  stateService = inject(StateService);
  loaderService = inject(AiHubLoaderService);
  isLoading$ = toSignal(this.loaderService.loader$);

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  ngOnInit(): void {
    this.stateService.getProfileApi();
  }

  save(profileEvent): void {
    const appProfile: AppProfile = profileEvent;
    this.askGenAi(appProfile);
  }

  askGenAi(appProfile): void {
    this.stateService.updateProfile(appProfile);
    const promptConfiguration: PromptConfig = {
      promptIdentifier: "profile_summary",
      replacementDict: appProfile,
    };
    this.stateService.askGenAiApi(
      promptConfiguration,
      "profileSummary",
      "profile",
    );
  }
}
